import { render, staticRenderFns } from "./ToolTargetPreferredObjectStorePopover.vue?vue&type=template&id=2368de7b&scoped=true"
import script from "./ToolTargetPreferredObjectStorePopover.vue?vue&type=script&lang=js"
export * from "./ToolTargetPreferredObjectStorePopover.vue?vue&type=script&lang=js"
import style0 from "./ToolTargetPreferredObjectStorePopover.vue?vue&type=style&index=0&id=2368de7b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2368de7b",
  null
  
)

export default component.exports